import apiCall from '../../plugins/api'

const state = { token: localStorage.getItem('token') || '', status: '', role: 'user' }

const getters = {
  isAuthenticated: state => !!state.token,
  getRole: state => state.role,
  authStatus: state => state.status
}

const actions = {
  ['AUTH_REQUEST']: ({ commit }, user) => {
    return new Promise((resolve, reject) => {
      commit('AUTH_REQUEST')
      apiCall({ url: '/api/auth', data: user, method: 'POST' })
        .then(resp => {
          if (resp.token) {
            localStorage.setItem('token', resp.token)
            commit('AUTH_SUCCESS', resp)
            resolve(resp)
          } else if (resp.status === 'authError') {
            commit('AUTH_ERROR', resp.payload.error)
            localStorage.removeItem('token')
            reject(resp.payload.error)
          }
        })
        .catch(err => {
          commit('AUTH_ERROR', err)
          localStorage.removeItem('token')
          reject(err)
        })
    })
  },
  ['AUTH_LOGOUT']: ({ commit }) => {
    return new Promise((resolve, reject) => {
      commit('AUTH_LOGOUT')
      apiCall({ url: '/api/logout', data: '', method: 'POST' })
        .then(resp => {
          commit('AUTH_LOGOUT')
          localStorage.removeItem('token')
          resolve(resp)
        })
        .catch(err => {
          commit('AUTH_ERROR', err)
          localStorage.removeItem('token')
          reject(err)
        })
    })
  }
}

const mutations = {
  ['AUTH_REQUEST']: (state) => {
    state.status = 'loading'
  },
  ['AUTH_SUCCESS']: (state, resp) => {
    state.status = 'success'
    state.token = resp.token
    state.role = resp.role
  },
  ['AUTH_ERROR']: (state) => {
    state.status = 'error'
    state.token = ''
    state.role = 'user'
  },
  ['AUTH_LOGOUT']: (state) => {
    state.token = ''
    state.role = 'user'
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
